import React from 'react';
import { COLORS } from '../../constants';
import aboutUsImage1 from '../../assets/About_us_Image_1.jpg';
import aboutUsImage2 from '../../assets/About_us_Image_2.jpg';

// Social Media Icons
const InstagramIcon = ({ size = 16, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const LinkedInIcon = ({ size = 16, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const AboutUs = () => {
  return (
    <div style={portfolioStyles.pageContainer}>
      {/* Hero Section */}
      <div style={portfolioStyles.heroSection}>
        <div style={portfolioStyles.heroContent}>
          <div style={portfolioStyles.heroText}>
            <h1 style={portfolioStyles.heroTitle}>Hi, I'm Neer Jain</h1>
            <h2 style={portfolioStyles.heroSubtitle}>Computer Science Student & Founder of Redbird Markets</h2>
            <p style={portfolioStyles.heroDescription}>
              I'm a Computer Science student at Illinois State University, and the creator of Redbird Markets:
              a student-built marketplace designed exclusively for ISU students, faculty, and staff.
            </p>
          </div>
          <div style={portfolioStyles.heroImage}>
            <img 
              src={aboutUsImage1} 
              alt="Neer Jain - Founder of Redbird Markets" 
              style={portfolioStyles.heroImageActual}
            />
          </div>
        </div>
      </div>

      <div style={portfolioStyles.contentContainer}>
        {/* Origin Story Section */}
        <section style={portfolioStyles.section}>
          <h2 style={portfolioStyles.sectionTitle}>The Story Behind Redbird Markets</h2>
          <div style={portfolioStyles.storyGrid}>
            <div style={portfolioStyles.storyText}>
              <p style={portfolioStyles.text}>
                I started Redbird Markets because I saw a gap on campus. There wasn't a safe, centralized way 
                for students to buy, sell, and connect within our own community. So I built one.
              </p>
              <p style={portfolioStyles.text}>
                From late-night brainstorming sessions in CVA to countless hours of coding, testing, 
                and feedback from friends, this project became something bigger than I imagined. It became a platform that 
                connects Redbirds through trust, technology, and teamwork.
              </p>
            </div>
            <div style={portfolioStyles.storyImage}>
              <img 
                src={aboutUsImage2} 
                alt="Late-night coding sessions at CVA: building the first Redbird Markets prototype" 
                style={portfolioStyles.storyImageActual}
              />
            </div>
          </div>
        </section>

        {/* Journey Section */}
        <section style={portfolioStyles.section}>
          <h2 style={portfolioStyles.sectionTitle}>How It Started</h2>
          <p style={portfolioStyles.text}>
            When I joined ISU, I became deeply involved in student life and leadership: serving as President of 
            ITSA (Information Technology Students of America), Student IT Representative for the CAST Council, and later as CAST Senator 
            within the Student Government Association (SGA).
          </p>
          <p style={portfolioStyles.text}>
            Through these roles, I met hundreds of students who had great ideas but limited access to tools or 
            platforms that supported them. That's where the idea for Redbird Markets was born, a secure marketplace 
            built by students, for students.
          </p>
          <p style={portfolioStyles.text}>
            This project combines everything I'm passionate about: technology, leadership and creating 
            real change that people can see and use every day.
          </p>
        </section>

        {/* Platform Features */}
        <section style={portfolioStyles.section}>
          <h2 style={portfolioStyles.sectionTitle}>What Redbird Markets Means to Me</h2>
          <p style={portfolioStyles.text}>
            Redbird Markets isn't just code and servers, it's a community effort. Every listing, every message, 
            every meet-up represents the kind of collaboration that makes ISU special.
          </p>
          
          <div style={portfolioStyles.featuresGrid}>
            <div className="about-feature-card" style={portfolioStyles.featureCard}>
              <h3 style={portfolioStyles.featureTitle}>Verified ISU-only signups</h3>
              <p style={portfolioStyles.featureDescription}>Keeping our community safe and trusted</p>
            </div>
            <div className="about-feature-card" style={portfolioStyles.featureCard}>
              <h3 style={portfolioStyles.featureTitle}>Direct messaging</h3>
              <p style={portfolioStyles.featureDescription}>Connect buyers and sellers seamlessly</p>
            </div>
            <div className="about-feature-card" style={portfolioStyles.featureCard}>
              <h3 style={portfolioStyles.featureTitle}>Meetup scheduling</h3>
              <p style={portfolioStyles.featureDescription}>Location tools for safe exchanges</p>
            </div>
            <div className="about-feature-card" style={portfolioStyles.featureCard}>
              <h3 style={portfolioStyles.featureTitle}>Secure payments</h3>
              <p style={portfolioStyles.featureDescription}>Stripe-powered transaction system</p>
            </div>
          </div>

          <p style={portfolioStyles.text}>
            I built it not just as a website, but as a movement that brings students together, responsibly, 
            creatively, and safely.
          </p>
        </section>

        {/* Leadership Journey */}
        <section style={portfolioStyles.section}>
          <h2 style={portfolioStyles.sectionTitle}>My Journey at ISU</h2>
          <div style={portfolioStyles.achievementGrid}>
            <div className="about-achievement-card" style={portfolioStyles.achievementCard}>
              <h3 style={portfolioStyles.achievementTitle}>ITSA President</h3>
              <p style={portfolioStyles.achievementDescription}>
                Led the Information Technology Students of America chapter, organizing major campus events 
                like the IT Internship Fair, 2024 and other major events.
              </p>
            </div>
            <div className="about-achievement-card" style={portfolioStyles.achievementCard}>
              <h3 style={portfolioStyles.achievementTitle}>CAST Senator</h3>
              <p style={portfolioStyles.achievementDescription}>
                Currently serving as the CAST Senator in SGA, advocating for student voices and campus innovation initiatives.
              </p>
            </div>
            <div className="about-achievement-card" style={portfolioStyles.achievementCard}>
              <h3 style={portfolioStyles.achievementTitle}>Research & Conferences</h3>
              <p style={portfolioStyles.achievementDescription}>
                Presented AI research and projects under ISU faculty mentorship, representing ISU at 
                research and leadership conferences.
              </p>
            </div>
          </div>

          <p style={portfolioStyles.text}>
            All these experiences shaped how I think about leadership, not as a title, but as a chance to create impact. 
            And Redbird Markets is my way of giving something back to the campus that gave me those opportunities.
          </p>
        </section>

        {/* Future Vision */}
        <section style={portfolioStyles.section}>
          <h2 style={portfolioStyles.sectionTitle}>What's Next</h2>
          <p style={portfolioStyles.text}>
            Redbird Markets will keep growing with new features, new partnerships, and maybe one day, expanding to 
            other campuses. But ISU will always be its home, and its foundation will always belong to Redbirds.
          </p>
        </section>

        {/* Contact Section */}
        <section style={portfolioStyles.contactSection}>
          <h2 style={portfolioStyles.contactSectionTitle}>Let's Connect</h2>
          <p style={portfolioStyles.contactSectionText}>
            If you'd like to connect, collaborate, or share ideas, reach out anytime!
          </p>
          <div style={portfolioStyles.contactLinks}>
            <a href="https://instagram.com/redbirdmarkets.isu" target="_blank" rel="noopener noreferrer" className="about-contact-link" style={portfolioStyles.contactLink}>
              <InstagramIcon size={18} color={COLORS.primary} />
              Instagram
            </a>
            <a href="https://linkedin.com/in/neerjain04" target="_blank" rel="noopener noreferrer" className="about-contact-link" style={portfolioStyles.contactLink}>
              <LinkedInIcon size={18} color={COLORS.primary} />
              LinkedIn
            </a>
          </div>
        </section>
      </div>
    </div>
  );
};

// Portfolio-style custom styles
const portfolioStyles = {
  pageContainer: {
    minHeight: '100vh',
    backgroundColor: '#fafafa',
  },
  
  // Hero Section
  heroSection: {
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, ${COLORS.primaryDark} 100%)`,
    color: 'white',
    padding: '80px 20px',
    position: 'relative',
    overflow: 'hidden',
  },
  heroContent: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: '1fr 300px',
    gap: '60px',
    alignItems: 'center',
    '@media (max-width: 768px)': {
      gridTemplateColumns: '1fr',
      gap: '40px',
      textAlign: 'center',
    },
  },
  heroText: {
    maxWidth: '600px',
  },
  heroTitle: {
    fontSize: '3.5rem',
    fontWeight: '700',
    marginBottom: '16px',
    lineHeight: '1.1',
    background: 'linear-gradient(45deg, #ffffff, #f0f0f0)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  },
  heroSubtitle: {
    fontSize: '1.5rem',
    fontWeight: '400',
    marginBottom: '24px',
    opacity: '0.9',
    lineHeight: '1.4',
  },
  heroDescription: {
    fontSize: '1.1rem',
    lineHeight: '1.6',
    opacity: '0.85',
    marginBottom: '0',
  },
  heroImage: {
    display: 'flex',
    justifyContent: 'center',
  },
  heroImageActual: {
    width: '280px',
    height: '320px',
    objectFit: 'cover',
    borderRadius: '16px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
    border: `4px solid white`,
  },
  
  // Content Container
  contentContainer: {
    maxWidth: '1000px',
    margin: '0 auto',
    padding: '80px 20px',
  },
  
  // Section Styles
  section: {
    marginBottom: '80px',
  },
  sectionTitle: {
    fontSize: '2.5rem',
    fontWeight: '700',
    color: COLORS.primary,
    marginBottom: '32px',
    textAlign: 'center',
    position: 'relative',
  },
  
  // Story Grid
  storyGrid: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gap: '60px',
    alignItems: 'center',
    marginBottom: '40px',
    '@media (max-width: 768px)': {
      gridTemplateColumns: '1fr',
      gap: '40px',
    },
  },
  storyText: {
    fontSize: '1.1rem',
  },
  storyImage: {
    display: 'flex',
    justifyContent: 'center',
  },
  storyImageActual: {
    width: '280px',
    height: '320px',
    objectFit: 'cover',
    borderRadius: '16px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
    border: `4px solid ${COLORS.primary}20`,
  },
  
  // Features Grid
  featuresGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px',
    margin: '40px 0',
  },
  featureCard: {
    background: 'white',
    padding: '28px',
    borderRadius: '16px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
    border: `1px solid ${COLORS.border || '#e5e7eb'}`,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    cursor: 'pointer',
    position: 'relative',
    overflow: 'hidden',
  },
  featureTitle: {
    fontSize: '1.2rem',
    fontWeight: '700',
    color: COLORS.primary,
    marginBottom: '12px',
    margin: '0 0 12px 0',
  },
  featureDescription: {
    fontSize: '1rem',
    color: COLORS.text.secondary,
    lineHeight: '1.6',
    margin: '0',
  },
  
  // Achievement Grid
  achievementGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '24px',
    marginBottom: '60px',
  },
  achievementCard: {
    background: 'white',
    padding: '32px',
    borderRadius: '20px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
    border: `1px solid ${COLORS.border || '#e5e7eb'}`,
    position: 'relative',
    overflow: 'hidden',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    cursor: 'pointer',
  },
  achievementTitle: {
    fontSize: '1.4rem',
    fontWeight: '700',
    color: COLORS.primary,
    marginBottom: '16px',
    position: 'relative',
    zIndex: '2',
    margin: '0 0 16px 0',
  },
  achievementDescription: {
    fontSize: '1rem',
    lineHeight: '1.7',
    color: COLORS.text.secondary,
    margin: '0',
    position: 'relative',
    zIndex: '2',
  },
  
  // Leadership Image
  leadershipImage: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '40px',
  },
  leadershipImageActual: {
    width: '280px',
    height: '320px',
    objectFit: 'cover',
    borderRadius: '16px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
    border: `4px solid ${COLORS.primary}20`,
  },
  
  // Contact Section
  contactSection: {
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, #9d0d1d 100%)`,
    padding: '80px 40px',
    borderRadius: '24px',
    textAlign: 'center',
    boxShadow: `0 4px 20px ${COLORS.primary}30`,
    color: 'white',
  },
  contactLinks: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    marginTop: '40px',
    flexWrap: 'wrap',
  },
  contactLink: {
    background: 'white',
    color: COLORS.primary,
    textDecoration: 'none',
    fontSize: '1.1rem',
    fontWeight: '600',
    padding: '16px 32px',
    borderRadius: '50px',
    border: 'none',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
  },
  
  // Contact Section Text Styles
  contactSectionTitle: {
    fontSize: '2.5rem',
    fontWeight: '700',
    color: 'white',
    marginBottom: '20px',
    textAlign: 'center',
    margin: '0 0 20px 0',
  },
  contactSectionText: {
    fontSize: '1.2rem',
    lineHeight: '1.6',
    color: 'rgba(255, 255, 255, 0.9)',
    marginBottom: '0',
    textAlign: 'center',
  },
  
  // Text Styles
  text: {
    fontSize: '1.1rem',
    lineHeight: '1.7',
    color: COLORS.text.primary,
    marginBottom: '24px',
    textAlign: 'left',
  },
  
  // Image Placeholders (for you to replace with actual photos)
  imagePlaceholder: {
    width: '280px',
    height: '320px',
    background: `linear-gradient(135deg, ${COLORS.lightGray}, #e0e0e0)`,
    borderRadius: '16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
    border: `3px dashed ${COLORS.primary}50`,
  },
  imagePlaceholderText: {
    fontSize: '1.1rem',
    fontWeight: '600',
    color: COLORS.primary,
    marginBottom: '12px',
    textAlign: 'center',
  },
  imagePlaceholderSubtext: {
    fontSize: '0.9rem',
    color: COLORS.text.secondary,
    textAlign: 'center',
    fontStyle: 'italic',
    lineHeight: '1.4',
    margin: '0',
  },
};

// Add hover effects and animations
const aboutUsStyles = `
  .about-feature-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 40px rgba(206, 17, 38, 0.15) !important;
    border-color: ${COLORS.primary}40 !important;
  }
  
  .about-feature-card:hover::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, ${COLORS.primary}, #9d0d1d);
    border-radius: 16px 16px 0 0;
  }
  
  .about-achievement-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 40px rgba(206, 17, 38, 0.15) !important;
  }
  
  .about-achievement-card:hover::before {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background: linear-gradient(135deg, ${COLORS.primary}, #9d0d1d);
    border-radius: 22px;
    z-index: -1;
    opacity: 0.1;
  }
  
  .about-contact-link:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
    background: #f8f9fa !important;
  }
  
  .about-contact-link:active {
    transform: translateY(0);
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleElement = document.getElementById('about-us-styles');
  if (!styleElement) {
    const style = document.createElement('style');
    style.id = 'about-us-styles';
    style.textContent = aboutUsStyles;
    document.head.appendChild(style);
  }
}

export default AboutUs;